<template>
  <div v-if="! hasCommission" class="w-full">
    <div class="mx-4 mt-4 mb-1">
      <div
        class="alert alert-danger">
        <div>
          {{ trans("dashboard.notifications.inactive_partner_account") }}
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>

import {usePage} from "@inertiajs/vue3";

const hasCommission = usePage().props.user.partner.hasCommission;
</script>
